import React from 'react';
import { CounterContainer, IconButton, NumberDisplay } from './styles';
import Typography from '../typograhy';
var IncrementDecrementComponent = function (_a) {
    var number = _a.number, setNumber = _a.setNumber, _b = _a.maxLimit, maxLimit = _b === void 0 ? Number.MAX_SAFE_INTEGER : _b, _c = _a.minLimit, minLimit = _c === void 0 ? 0 : _c, _d = _a.size, size = _d === void 0 ? 'md' : _d;
    var onIncrease = function () {
        if (number < maxLimit) {
            setNumber(number + 1, 'inc');
        }
    };
    var onDecrease = function () {
        if (number > minLimit) {
            setNumber(number - 1, 'dec');
        }
    };
    return (React.createElement(CounterContainer, { size: size },
        React.createElement(IconButton, { onClick: onDecrease, disabled: number <= minLimit, size: size, "data-testid": "subIcon" }, "\u2013"),
        React.createElement(NumberDisplay, { size: size },
            React.createElement(Typography, { variant: "subtitle2", fontWeight: "regular" }, number)),
        React.createElement(IconButton, { onClick: onIncrease, disabled: number >= maxLimit, size: size, "data-testid": "addIcon" }, "+")));
};
export default IncrementDecrementComponent;
